type ShouldSkipOwnPubSubEventArgs = {
	accountId?: string | null;
	currentUserId?: string | null;
	isReply: boolean;
	isOwnReplyPubSubProcessingEnabled: boolean;
};

// Temporary override for agent-created comments. Agents create comments through public APIs,
// so their pubsub events currently look like current-user events to the frontend. Once pubsub
// events carry creation context, this can be replaced with a context-aware check.
export const shouldSkipOwnPubSubEvent = ({
	accountId = null,
	currentUserId = null,
	isReply,
	isOwnReplyPubSubProcessingEnabled,
}: ShouldSkipOwnPubSubEventArgs): boolean => {
	if (accountId !== currentUserId) {
		return false;
	}

	if (!isReply) {
		return true;
	}

	return !isOwnReplyPubSubProcessingEnabled;
};
